<template>
<div>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <v-card class="pa-3">
            <div class="mb-3">
                <h2>งบกำไรขาดทุน</h2>
            </div>
            <div class="mb-3 d-flex justify-end option_date_income_statement_list">
                <div class="mr-1">
                    <v-select label="ประเภท" v-model="type" :items="type_list" item-text="name" item-value="value" color="warning" hide-details="auto" outlined>
                    </v-select>
                </div>
                <div class="ml-1">
                    <v-select label="งวด" v-model="lesson" :items="lesson_list" item-text="name" item-value="id" @change="incomeStatementList()" color="warning" hide-details="auto" outlined>
                    </v-select>
                </div>
            </div>
            <div class="mb-3">
                 <div class="chart_income_statement_list d-flex justify-center align-center">
                    <canvas id="my-chart"></canvas>
                </div>
            </div>
            <div>
                <v-simple-table fixed-header>
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th :colspan="col_span"></th>
                                <th class="text-right" v-for="(date_detail,index) in date_list" :key="index">
                                    {{
                                         date_detail
                                    }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr style="background-color:#eeeeee;">
                                <td colspan="9">
                                    <h4>รายได้</h4>
                                </td>
                            </tr>
                            <tr>
                                <td :colspan="col_span">
                                    <div class="pl-5">รายได้จากการขายสินค้า</div>
                                </td>
                                <td class="text-right" v-for="(income_store_detail,index) in income_store_list" :key="index">
                                    {{
                                        Intl.NumberFormat().format(income_store_detail)
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <td :colspan="col_span">
                                    <div class="pl-5">รายได้จากเดลิเวอรี่</div>
                                </td>
                                <td class="text-right" v-for="(income_other_detail,index) in income_other_list" :key="index">
                                    {{
                                        Intl.NumberFormat().format(income_other_detail)
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <td :colspan="col_span">
                                    <h4>รวมรายได้</h4>
                                </td>
                                <td class="text-right" v-for="(total_income_detail,index) in total_income_list" :key="index">
                                    {{
                                        Intl.NumberFormat().format(total_income_detail)
                                    }}
                                </td>
                            </tr>
                            <tr style="background-color:#eeeeee;">
                                <td colspan="9">
                                    <h4>ค่าใช้จ่าย</h4>
                                </td>
                            </tr>
                            <tr>
                                <td :colspan="col_span">
                                    <div class="pl-5">ค่าใช้จ่ายทั้งหมด</div>
                                </td>
                                <td class="text-right" v-for="(cost_sale_detail,index) in cost_sale_list" :key="index">
                                    {{
                                        Intl.NumberFormat().format(cost_sale_detail)
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <td :colspan="col_span">
                                    <div class="pl-5">ชำระหนี้</div>
                                </td>
                                <td class="text-right" v-for="(cost_manage_detail,index) in pay_off_debt_list" :key="index">
                                    {{
                                        Intl.NumberFormat().format(cost_manage_detail)
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <td :colspan="col_span">
                                    <h4>รวมค่าใช้จ่าย</h4>
                                </td>
                                <td class="text-right" v-for="(total_cost_detail,index) in total_cost_list" :key="index">
                                    {{
                                        Intl.NumberFormat().format(total_cost_detail)
                                    }}
                                </td>
                            </tr>
                            <tr style="background-color:#eeeeee;">
                                <td :colspan="col_span">
                                    <h4>กำไรสุทธิ</h4>
                                </td>
                                <td class="text-right" v-for="(net_profit_detail,index) in net_profit_list" :key="index">
                                    {{
                                        Intl.NumberFormat().format(net_profit_detail)
                                    }}
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </div>

        </v-card>

    </div>
</div>
</template>

<script>
import Chart from 'chart.js/auto'
// import 'chartjs-plugin-labels'
import incomestatement from '@/api/account/accountreport/incomestatement.js'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: false,
            type_list: [{
                    value: 'm',
                    name: 'รายเดือน'
                },
                {
                    value: 'y',
                    name: 'รายปี'
                },
            ],
            lesson_list: [],
            type: null,
            lesson: null,
            col_span: 9,
            date_list: [],
            income_store_list: [],
            income_other_list: [],
            total_income_list: [],
            cost_sale_list: [],
            pay_off_debt_list: [],
            total_cost_list: [],
            net_profit_list:[],
        }
    },
    methods: {
        async incomeStatementList() {
            this.loading_page = true
            this.col_span = 9
            this.date_list = []
            this.income_store_list = []
            this.income_other_list = []
            this.total_income_list = []
            this.cost_sale_list = []
            this.pay_off_debt_list = []
            this.total_cost_list = []
            this.net_profit_list = []
            await incomestatement.incomeStatementList(this.type, this.lesson).then((response) => {
                if (response.data.successful === true) {
                    if (this.type === 'm') {
                        response.data.detail.forEach((detail) => {
                            this.col_span -= 1
                            this.date_list.push(`วันที่ ${new Date(new Date().getFullYear(), detail.date, 0).getDate()} ${this.$store.state.monthList[detail.date - 1].name}`)
                            this.income_store_list.push(detail.incomStore)
                            this.income_other_list.push(detail.incomOther)
                            this.total_income_list.push(detail.totalIncom)
                            this.cost_sale_list.push(detail.costSale)
                            this.pay_off_debt_list.push(detail.payOffDebt)
                            this.total_cost_list.push(detail.totalCost)
                            this.net_profit_list.push(detail.totalIncom - detail.totalCost)
                        })
                    }
                    if (this.type === 'y') {
                        response.data.detail.forEach((detail) => {
                            this.col_span -= 1
                            this.date_list.push(`ปี ${parseFloat(detail.date) + 543}`)
                            this.income_store_list.push(detail.incomStore)
                            this.income_other_list.push(detail.incomOther)
                            this.total_income_list.push(detail.totalIncom)
                            this.cost_sale_list.push(detail.costSale)
                            this.pay_off_debt_list.push(detail.payOffDebt)
                            this.total_cost_list.push(detail.totalCost)
                            this.net_profit_list.push(detail.totalIncom - detail.totalCost)
                        })
                    }
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })

            let ctx_store = document.getElementById('my-chart')
            new Chart(ctx_store, {
                    type: 'bar',
                    data: {
                        labels: this.date_list.map((detail) => {
                            return detail
                        }),
                        datasets: [
                            {
                                label: 'กำไรสุทธิ',
                                data: this.net_profit_list.map((detail) => {
                                    return detail
                                }),
                                borderColor: 'rgb(9, 206, 51)',
                                fill: false,
                                tension: 0.1,
                                backgroundColor: this.net_profit_list.map((detail) => {
                                    if (detail >= 0) {
                                        return '#4caf50'
                                    }
                                    if (detail < 0) {
                                        return '#ff5252'
                                    }
                                }),

                            },
                        ]

                    },
                    options: {
                        legend: {
                            display: false
                        },
                        responsive: true,
                        maintainAspectRatio: true,
                        plugins: {
                            labels: {
                                render: 'value',
                                fontSize: 'unset',
                                fontColor: this.net_profit_list.map(() => {
                                    return '#000000'
                                }),
                                precision: 2,
                            }
                        },
                    scales: {
                        xAxes: [{
                            stacked: true
                        }],
                        yAxes: [{
                            stacked: true,
                            ticks: {
                                max: this.type && this.lesson ? Math.max(...this.net_profit_list) + 5000 : 5000,
                                beginAtZero: true
                            }
                        }]
                    },
                }
            })
            
        },
    },
    mounted() {
        this.incomeStatementList()
    },
    watch: {
        type: function (val) {
            this.lesson = null
            if (val == 'm') {
                this.lesson_list = [{
                        id: 1,
                        name: '1 เดือน'
                    },
                    {
                        id: 2,
                        name: '2 เดือน'
                    },
                    {
                        id: 3,
                        name: '3 เดือน'
                    },
                    {
                        id: 4,
                        name: '4 เดือน'
                    },
                    {
                        id: 5,
                        name: '5 เดือน'
                    },
                    {
                        id: 6,
                        name: '6 เดือน'
                    },
                ]
            }
            if (val == 'y') {
                this.lesson_list = [{
                        id: 1,
                        name: '1 ปี'
                    },
                    {
                        id: 2,
                        name: '2 ปี'
                    },
                    {
                        id: 3,
                        name: '3 ปี'
                    },
                    {
                        id: 4,
                        name: '4 ปี'
                    },
                    {
                        id: 5,
                        name: '5 ปี'
                    },
                    {
                        id: 6,
                        name: '6 ปี'
                    },
                ]
            }
        }
    }
}
</script>

<style scoped>
.option_date_income_statement_list>div {
    width: 20%;
}

.chart_income_statement_list{
    height: 100%;
}
</style>
